import React from 'react';

import ProgramSection from '../../components/ProgramSection';

function Government() {
  return (
    <ProgramSection
      category="government"
      breadcrumb="Government & Public Sectors"
      titlePlain="Government &"
      titleAccent="Public Sectors"
      subtitle="Financial literacy programs we have delivered with government agencies and public institutions."
    />
  );
}

export default Government;
